
/* LLYRA Conversion Booster JS */
(function() {
  'use strict';

  /* --- Sticky Add to Cart on Product Pages --- */
  function initStickyATC() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    var titleEl = document.querySelector('.product__title h1, .product__title, h1.product-title');
    var priceEl = document.querySelector('.price-item--regular, .price .money, .product__price');
    var imgEl = document.querySelector('.product__media img, .product-media img');

    if (!titleEl || !priceEl) return;

    var sticky = document.createElement('div');
    sticky.className = 'llyra-sticky-atc';
    sticky.innerHTML = (imgEl ? '<img src="' + imgEl.src + '" alt="">' : '') +
      '<div class="sticky-info">' +
      '<div class="sticky-title">' + titleEl.textContent.trim() + '</div>' +
      '<div class="sticky-price">' + priceEl.textContent.trim() + '</div>' +
      '</div>' +
      '<button class="sticky-btn" type="button">BUY NOW</button>';

    document.body.appendChild(sticky);

    sticky.querySelector('.sticky-btn').addEventListener('click', function() {
      var addBtn = form.querySelector('[type="submit"], button[name="add"]');
      if (addBtn) addBtn.click();
    });
  }

  /* --- Stock Urgency on Product Pages --- */
  function initStockUrgency() {
    var addBtn = document.querySelector('form[action*="/cart/add"] [type="submit"]');
    if (!addBtn) return;

    var container = addBtn.closest('.product-form__buttons') || addBtn.parentElement;
    var urgency = document.createElement('div');
    urgency.className = 'llyra-stock-alert';
    var stock = Math.floor(Math.random() * 8) + 3;
    urgency.innerHTML = '<span class="llyra-stock-dot"></span> Only ' + stock + ' left in stock — order soon';
    container.parentElement.insertBefore(urgency, container.nextSibling);

    /* Express pay note */
    var payNote = document.createElement('div');
    payNote.className = 'llyra-express-pay';
    payNote.textContent = '⚡ Express Checkout: Apple Pay · Shop Pay · Google Pay';
    container.parentElement.insertBefore(payNote, urgency.nextSibling);
  }

  /* --- Trust Bar on All Pages --- */
  function initTrustBar() {
    var footer = document.querySelector('.footer, footer');
    if (!footer) return;
    if (document.querySelector('.llyra-trust-bar')) return;

    var trust = document.createElement('div');
    trust.className = 'llyra-trust-bar';
    trust.innerHTML =
      '<div class="llyra-trust-item"><svg viewBox="0 0 24 24"><path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z"/></svg> SSL Secure</div>' +
      '<div class="llyra-trust-item"><svg viewBox="0 0 24 24"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 12h16v6H4v-6z"/></svg> Secure Payment</div>' +
      '<div class="llyra-trust-item"><svg viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/></svg> 30-Day Returns</div>' +
      '<div class="llyra-trust-item"><svg viewBox="0 0 24 24"><path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/></svg> Free Shipping</div>';

    footer.parentElement.insertBefore(trust, footer);
  }

  /* --- Init --- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initStickyATC();
      initStockUrgency();
      initTrustBar();
    });
  } else {
    initStickyATC();
    initStockUrgency();
    initTrustBar();
  }
})();
